import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Heading from '@components/ui/Heading';
import { usePdp } from '@context/PdpContext';
import { BASE64_BLUR_DATA } from '@utils/constants';
import GeoLocationButton from '@components/global/GeoLocationButton';

import styles from './FixedHeader.module.scss';

const FixedHeader = ({ headingId }: { headingId: string }) => {
  const { t } = useTranslation('pdp');
  const { name, selectedColour, selectedSize, selectedVariant } = usePdp();

  return (
    <>
      <Heading
        className={styles.heading}
        semanticLevel="h2"
        styleLevel="3"
        id={headingId}
      >
        {t('product.modal.stockLevel.title')}
      </Heading>
      <div className={styles.selectedProduct}>
        <GeoLocationButton classNames={styles.geoLocationButton} />
        {selectedVariant && (
          <>
            <div className={styles.productImage}>
              {selectedVariant?.defaultImage && (
                <Image
                  src={
                    selectedVariant.defaultImage.thumbnail ??
                    selectedVariant.defaultImage.urlOriginal
                  }
                  alt={selectedVariant.defaultImage.altText}
                  width={64}
                  height={64}
                  className={styles.image}
                  blurDataURL={BASE64_BLUR_DATA}
                  placeholder="blur"
                  sizes="128px"
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'contain',
                    objectPosition: 'center',
                  }}
                />
              )}
            </div>
            <div className={styles.textArea}>
              <Heading
                className={styles.heading}
                semanticLevel="h4"
                styleLevel="7"
              >
                {name}
              </Heading>
              <p className={styles.variantInfo}>
                {selectedColour && selectedColour.name !== 'NO_COLOUR' && (
                  <>
                    {t('product.colour')} {selectedColour.name} <br />
                  </>
                )}
                {selectedSize && (
                  <>
                    {t('product.size')} {selectedSize.name}
                  </>
                )}
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default FixedHeader;
